import React, { Component } from "react";
import { Link } from "react-router";
import { Helmet } from "react-helmet";

import "./style.scss";

export default class Pricing extends Component {
  render() {
    const checkmark = (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#00D753"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    );
    const checkmarkArtist = (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#01B345"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    );
    const crossmark = (
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#FF0236"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    );

    return (
      <div className="aboss__pricing">
        <Helmet>
          <title>ABOSS - Pricing</title>
          <meta name="description" content="ABOSS - Pricing" />
        </Helmet>
        <div className="aboss__pricing-container">
          <table>
            <thead>
              <tr>
                <th>
                  <h1>Pricing</h1>
                </th>
                <th>Artist PRO</th>
                <th></th>
                <th colspan="3">Agency</th>
              </tr>
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th>Small</th>
                <th>Medium</th>
                <th>Large</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Calendars</strong>
                  Amount of calendars you can manage per subscription.
                </td>
                <td>1</td>
                <td></td>
                <td>10</td>
                <td>30</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td>
                  <strong>Users</strong>
                  Amount of users you can invite in your account.
                </td>
                <td>Unlimited</td>
                <td></td>
                <td>Unlimited</td>
                <td>Unlimited</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td>
                  <strong>Month Subscription</strong>
                  Cancel anytime you want, billed on a monthly basis.
                </td>
                <td className="price">
                  &euro; 49,-<span>monthly</span>
                </td>
                <td></td>
                <td className="price">
                  &euro; 145,-<span>monthly</span>
                </td>
                <td className="price">
                  &euro; 320,-<span>monthly</span>
                </td>
                <td className="price">
                  &euro; 580,-<span>monthly</span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Year Subscription</strong>
                  Pay annually and receive a discount on your subscription.
                </td>
                <td className="price">
                  &euro; 44,-<span>monthly</span>
                </td>
                <td></td>
                <td className="price">
                  &euro; 131,-<span>monthly</span>
                </td>
                <td className="price">
                  &euro; 288,-<span>monthly</span>
                </td>
                <td className="price">
                  &euro; 522,-<span>monthly</span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Dashboard</strong>
                  Track, filter and export your events with the information you
                  need.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Calendar</strong>
                  View all your events, meetings, travel items and blocks in a
                  single calendar.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>Connect to calendar software</strong>
                  Connect your ABOSS calendar to other software such as iCal or
                  Google Calendar.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>Publish tourdates</strong>
                  Publish your events on Facebook, bandsintown and website with
                  our integrations.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>Event availability</strong>
                  Add contacts to the event and request their availbility for
                  the event.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{crossmark}</td>
                <td>{crossmark}</td>
                <td>{crossmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>Flight number integration</strong>
                  Let ABOSS add all flight details by entering the flight
                  number.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Contacts</strong>
                  Manage all contacts in a single database and see all active
                  history with everyone.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>European VAT number check</strong>
                  Use our VIES integration to check european VAT numbers.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Invoices</strong>
                  Generate invoices based on your deals and track payment
                  status.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Contracts</strong>
                  Generate multiple contracts for your events and track their
                  status.
                </td>
                <td>{crossmark}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Locations</strong>
                  Manage all your locations in a single database and track all
                  history for every location.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Team permissions</strong>
                  Assign permissions to each internal user within the account on
                  a module basis.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>External users</strong>
                  Invite external users with viewing permisions to the calendar
                </td>
                <td>{crossmark}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>Label permissions</strong>
                  Assign specific user permissions based on labels of the event.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{crossmark}</td>
                <td>{crossmark}</td>
                <td>{crossmark}</td>
              </tr>
              <tr className="sub">
                <td>
                  <strong>Availability permissions</strong>
                  Assign specific user permissions based on availability of the
                  event.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{crossmark}</td>
                <td>{crossmark}</td>
                <td>{crossmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Statistics</strong>
                  Display your financial data of past & upcoming events with
                  line, bar and area graphs.
                </td>
                <td>{crossmark}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Custom email domain</strong>
                  Send all emails from ABOSS with your own email address with
                  our DNS settings.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td>
                  <strong>Mobile App</strong>
                  View all information on the mobile app, both on- and offline.
                </td>
                <td>{checkmarkArtist}</td>
                <td></td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
                <td>{checkmark}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <Link to="/trial">
                    <button>Start trial</button>
                  </Link>
                </td>
                <td></td>
                <td>
                  <Link to="/sign-up/agency#small">
                    <button>Sign Up</button>
                  </Link>
                </td>
                <td>
                  <Link to="/sign-up/agency#medium">
                    <button>Sign Up</button>
                  </Link>
                </td>
                <td>
                  <Link to="/sign-up/agency#large">
                    <button>Sign Up</button>
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/pricing/index.js